import React, { FunctionComponent, useEffect, useState } from 'react'
import { getAncestors } from 'Frontend/scripts/services/workrooms.service'
import { IWorkroomFolder } from 'Frontend/scripts/models/workrooms.model'
import { Breadcrumb, BreadcrumbItem } from 'react-bootstrap'
import { useWorkroom } from './WorkroomContext'
import { useTranslation } from 'react-i18next'

const WorkroomDocumentsBreadcrumb: FunctionComponent = () => {
  const { currentFolder, setCurrentActiveFolder, currentWorkroomId } = useWorkroom()
  const [breadcrumbs, setBreadcrumbs] = useState<IWorkroomFolder[]>([])
  const { t } = useTranslation()

  const fetchBreadcrumbs = async () => {
    if (!currentFolder || !currentWorkroomId) return
    if (currentFolder === 'root') {
      setBreadcrumbs([])
      return
    }

    try {
      getAncestors(currentWorkroomId as string, currentFolder).then((resp) => {
        setBreadcrumbs(resp)
      })
    } catch {
      console.error('Failed to load news categories')
    }
  }

  const handleFolderClick = (e: React.MouseEvent<HTMLAnchorElement>, folderId: string) => {
    e.preventDefault()
    setCurrentActiveFolder(folderId)
  }

  useEffect(() => {
    fetchBreadcrumbs()
  }, [currentFolder])

  return (
    <Breadcrumb>
      <BreadcrumbItem onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => handleFolderClick(e, 'root')}>
        {t('workrooms.documents.breadcrumbs-root-folder-name')}
      </BreadcrumbItem>
      {breadcrumbs.map((folderItem) => (
        <BreadcrumbItem
          key={`breadbrumb-item-${folderItem.id}`}
          onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) =>
            handleFolderClick(e, folderItem.id.toString())
          }
        >
          {folderItem.name}
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  )
}
export default WorkroomDocumentsBreadcrumb
